<template>
	<div :class="{ 'list': true, 'list--loading': loading }">
		<!-- Hide table entirely if set to only "new" reports and no results -->
		<Vuetable ref="vuetable" api-url="reports" :fields="fields" :css="css"
		          pagination-path="meta"
		          @vuetable:pagination-data="onPaginationData"
		          @vuetable:loading="onLoading"
		          @vuetable:loaded="onLoaded" @vuetable-load-error="onLoadError"
		          :http-fetch="fetch"
		          :append-params="reportFilters"
		          :load-on-start="loadOnStart"
		          :min-rows="loading ? 10 : null"
		          :no-data-template="loaded ? 'No reports found' : ''"
		></Vuetable>

		<!-- Error while loading -->
		<div class="list__error" v-if="error">
			<span class="h2">Unable to load reports.</span>
			<button class="btn btn--link" @click.prevent="load">Retry</button>
		</div>

		<Pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></Pagination>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Vuetable from 'vuetable-2/src/components/Vuetable';
	import ColumnReport from './ColumnReport';
	import Pagination from './Pagination';
	import FilterableList from './FilterableList';

	Vue.component('column-report', ColumnReport);

	export default {
		name: 'ListReports',
		mixins: [FilterableList],
		components: {
			Pagination,
			Vuetable,
		},
		props: {
			resource: {
				type: String,
				required: true,
			},
		},
		data() {
			return {
				fields: [
					{
						name: 'type',
						sortField: 'type',
						title: 'Report',
					},
					{
						name: 'fromDate',
						sortField: 'from_date',
						title: 'Between...',
						callback: 'formatDate',
						width: '175px',
					},
					{
						name: 'toDate',
						sortField: 'to_date',
						title: '...and',
						callback: 'formatDate',
						width: '175px',
					},
					{
						name: 'createdAt',
						sortField: 'created_at',
						title: 'Generated',
						titleClass: 'right',
						callback: 'formatDate',
						width: '175px',
					},
					{
						name: '__component:column-report',
						width: '250px',
					}
				],
			};
		},
		computed: {
			reportFilters() {
				let filters = JSON.parse(JSON.stringify(this.filters));

				filters.resource = this.resource;

				return filters;
			}
		}
	}
</script>
